import styled, { css } from 'styled-components';
import { px2rem } from '../helpers/rem.mjs';

/**
 * HEADING 1
 */
var H1RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(40), function (props) {
  return props.theme.font.regular;
}, px2rem(60));
var H1BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(40), function (props) {
  return props.theme.font.bold;
}, px2rem(60));
var H1Regular = styled.h1.withConfig({
  displayName: "H1Regular",
  componentId: "sc-yba282-0"
})(["display:block;", ""], H1RegularStyle);
var H1Bold = styled.h1.withConfig({
  displayName: "H1Bold",
  componentId: "sc-yba282-1"
})(["display:block;", ""], H1BoldStyle);
/**
 * HEADING 2
 */
var H2RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(32), function (props) {
  return props.theme.font.regular;
}, px2rem(48));
var H2BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(32), function (props) {
  return props.theme.font.bold;
}, px2rem(48));
var H2Regular = styled.h2.withConfig({
  displayName: "H2Regular",
  componentId: "sc-yba282-2"
})(["display:block;", ""], H2RegularStyle);
var H2Bold = styled.h2.withConfig({
  displayName: "H2Bold",
  componentId: "sc-yba282-3"
})(["display:block;", ""], H2BoldStyle);
/**
 * HEADING 3
 */
var H3RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(28), function (props) {
  return props.theme.font.regular;
}, px2rem(42));
var H3BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(28), function (props) {
  return props.theme.font.bold;
}, px2rem(42));
var H3Regular = styled.h3.withConfig({
  displayName: "H3Regular",
  componentId: "sc-yba282-4"
})(["display:block;", ""], H3RegularStyle);
var H3Bold = styled.h3.withConfig({
  displayName: "H3Bold",
  componentId: "sc-yba282-5"
})(["display:block;", ""], H3BoldStyle);
/**
 * HEADING 4
 */
var H4RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(24), function (props) {
  return props.theme.font.regular;
}, px2rem(36));
var H4BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(24), function (props) {
  return props.theme.font.bold;
}, px2rem(36));
var H4Regular = styled.h4.withConfig({
  displayName: "H4Regular",
  componentId: "sc-yba282-6"
})(["display:block;", ";"], H4RegularStyle);
var H4Bold = styled.h4.withConfig({
  displayName: "H4Bold",
  componentId: "sc-yba282-7"
})(["display:block;", ";"], H4BoldStyle);
/**
 * HEADING 5
 */
var H5RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(22), function (props) {
  return props.theme.font.regular;
}, px2rem(32));
var H5BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(22), function (props) {
  return props.theme.font.bold;
}, px2rem(32));
var H5Regular = styled.h5.withConfig({
  displayName: "H5Regular",
  componentId: "sc-yba282-8"
})(["display:block;", ";"], H5RegularStyle);
var H5Bold = styled.h5.withConfig({
  displayName: "H5Bold",
  componentId: "sc-yba282-9"
})(["display:block;", ";"], H5BoldStyle);
/**
 * HEADING 6
 */
var H6RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(20), function (props) {
  return props.theme.font.regular;
}, px2rem(30));
var H6BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(20), function (props) {
  return props.theme.font.bold;
}, px2rem(30));
var H6Regular = styled.h6.withConfig({
  displayName: "H6Regular",
  componentId: "sc-yba282-10"
})(["display:block;", ";"], H6RegularStyle);
var H6Bold = styled.h6.withConfig({
  displayName: "H6Bold",
  componentId: "sc-yba282-11"
})(["display:block;", ";"], H6BoldStyle);
/**
 * HEADING 7
 */
var H7RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(18), function (props) {
  return props.theme.font.regular;
}, px2rem(28));
var H7BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(18), function (props) {
  return props.theme.font.bold;
}, px2rem(28));
var H7Regular = styled.div.withConfig({
  displayName: "H7Regular",
  componentId: "sc-yba282-12"
})(["display:block;", ";"], H7RegularStyle);
var H7Bold = styled.div.withConfig({
  displayName: "H7Bold",
  componentId: "sc-yba282-13"
})(["display:block;", ";"], H7BoldStyle);
/**
 * HEADING 8
 */
var H8RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(16), function (props) {
  return props.theme.font.regular;
}, px2rem(22));
var H8BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(16), function (props) {
  return props.theme.font.bold;
}, px2rem(22));
var H8Regular = styled.div.withConfig({
  displayName: "H8Regular",
  componentId: "sc-yba282-14"
})(["display:block;", ";"], H8RegularStyle);
var H8Bold = styled.div.withConfig({
  displayName: "H8Bold",
  componentId: "sc-yba282-15"
})(["display:block;", ";"], H8BoldStyle);
/**
 * HEADING 9
 */
var H9RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(15), function (props) {
  return props.theme.font.regular;
}, px2rem(21));
var H9BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(15), function (props) {
  return props.theme.font.bold;
}, px2rem(21));
var H9Regular = styled.div.withConfig({
  displayName: "H9Regular",
  componentId: "sc-yba282-16"
})(["display:block;", ";"], H9RegularStyle);
var H9Bold = styled.div.withConfig({
  displayName: "H9Bold",
  componentId: "sc-yba282-17"
})(["display:block;", ";"], H9BoldStyle);
/**
 * HEADING 10
 */
var H10RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(14), function (props) {
  return props.theme.font.regular;
}, px2rem(20));
var H10BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(14), function (props) {
  return props.theme.font.bold;
}, px2rem(20));
var H10Regular = styled.div.withConfig({
  displayName: "H10Regular",
  componentId: "sc-yba282-18"
})(["display:block;", ";"], H10RegularStyle);
var H10Bold = styled.div.withConfig({
  displayName: "H10Bold",
  componentId: "sc-yba282-19"
})(["display:block;", ";"], H10BoldStyle);
/**
 * Body 1
 */
var B1RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(16), function (props) {
  return props.theme.font.regular;
}, px2rem(22));
var B1BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(16), function (props) {
  return props.theme.font.bold;
}, px2rem(22));
var B1Regular = styled.div.withConfig({
  displayName: "B1Regular",
  componentId: "sc-yba282-20"
})(["", ";"], B1RegularStyle);
var B1Bold = styled.div.withConfig({
  displayName: "B1Bold",
  componentId: "sc-yba282-21"
})(["", ";"], B1BoldStyle);
/**
 * paragraph Body 1
 */
var pB1RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(16), function (props) {
  return props.theme.font.regular;
}, px2rem(28));
var pB1BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(16), function (props) {
  return props.theme.font.bold;
}, px2rem(28));
var PB1Regular = styled.div.withConfig({
  displayName: "PB1Regular",
  componentId: "sc-yba282-22"
})(["", ";"], pB1RegularStyle);
var PB1Bold = styled.div.withConfig({
  displayName: "PB1Bold",
  componentId: "sc-yba282-23"
})(["", ";"], pB1BoldStyle);
/**
 * Body 2
 */
var BODY_TWO_LINE_HEIGHT = 21;
var B2RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(15), function (props) {
  return props.theme.font.regular;
}, px2rem(BODY_TWO_LINE_HEIGHT));
var B2BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(15), function (props) {
  return props.theme.font.bold;
}, px2rem(BODY_TWO_LINE_HEIGHT));
var B2Regular = styled.div.withConfig({
  displayName: "B2Regular",
  componentId: "sc-yba282-24"
})(["", ";"], B2RegularStyle);
var B2Bold = styled.div.withConfig({
  displayName: "B2Bold",
  componentId: "sc-yba282-25"
})(["", ";"], B2BoldStyle);
/**
 * paragraph Body 2
 */
var pB2RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(15), function (props) {
  return props.theme.font.regular;
}, px2rem(27));
var pB2BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(15), function (props) {
  return props.theme.font.bold;
}, px2rem(27));
var PB2Regular = styled.div.withConfig({
  displayName: "PB2Regular",
  componentId: "sc-yba282-26"
})(["", ";"], pB2RegularStyle);
var PB2Bold = styled.div.withConfig({
  displayName: "PB2Bold",
  componentId: "sc-yba282-27"
})(["", ";"], pB2BoldStyle);
/**
 * Body 3
 */
var BODY_THREE_LINE_HEIGHT = 20;
var B3RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(14), function (props) {
  return props.theme.font.regular;
}, px2rem(BODY_THREE_LINE_HEIGHT));
var B3BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(14), function (props) {
  return props.theme.font.bold;
}, px2rem(BODY_THREE_LINE_HEIGHT));
var B3Regular = styled.div.withConfig({
  displayName: "B3Regular",
  componentId: "sc-yba282-28"
})(["", ";"], B3RegularStyle);
var B3Bold = styled.div.withConfig({
  displayName: "B3Bold",
  componentId: "sc-yba282-29"
})(["", ";"], B3BoldStyle);
/**
 * paragraph Body 3
 */
var pB3RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(14), function (props) {
  return props.theme.font.regular;
}, px2rem(24));
var pB3BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(14), function (props) {
  return props.theme.font.bold;
}, px2rem(24));
var PB3Regular = styled.div.withConfig({
  displayName: "PB3Regular",
  componentId: "sc-yba282-30"
})(["", ";"], pB3RegularStyle);
var PB3Bold = styled.div.withConfig({
  displayName: "PB3Bold",
  componentId: "sc-yba282-31"
})(["", ";"], pB3BoldStyle);
/**
 * Body 3
 */
var B4RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(12), function (props) {
  return props.theme.font.regular;
}, px2rem(16));
var B4BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(12), function (props) {
  return props.theme.font.bold;
}, px2rem(16));
var B4Regular = styled.div.withConfig({
  displayName: "B4Regular",
  componentId: "sc-yba282-32"
})(["", ";"], B4RegularStyle);
var B4Bold = styled.div.withConfig({
  displayName: "B4Bold",
  componentId: "sc-yba282-33"
})(["", ";"], B4BoldStyle);
/**
 * paragraph Body 3
 */
var pB4RegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(12), function (props) {
  return props.theme.font.regular;
}, px2rem(20));
var pB4BoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(12), function (props) {
  return props.theme.font.bold;
}, px2rem(20));
var PB4Regular = styled.div.withConfig({
  displayName: "PB4Regular",
  componentId: "sc-yba282-34"
})(["", ";"], pB4RegularStyle);
var PB4Bold = styled.div.withConfig({
  displayName: "PB4Bold",
  componentId: "sc-yba282-35"
})(["", ";"], pB4BoldStyle);
var CaptionRegularStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(11), function (props) {
  return props.theme.font.regular;
}, px2rem(17));
var CaptionBoldStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(11), function (props) {
  return props.theme.font.bold;
}, px2rem(17));
var CaptionRegular = styled.div.withConfig({
  displayName: "CaptionRegular",
  componentId: "sc-yba282-36"
})(["", ";"], CaptionRegularStyle);
var CaptionBold = styled.div.withConfig({
  displayName: "CaptionBold",
  componentId: "sc-yba282-37"
})(["", ";"], CaptionBoldStyle);
/**
 * LABEL
 */
var LabelStyle = css(["font-size:", ";font-weight:", ";line-height:", ";"], px2rem(16), function (props) {
  return props.theme.font.regular;
}, px2rem(22));
var Label = styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-yba282-38"
})(["", ";"], LabelStyle);
var EmptyComponent = styled.div.withConfig({
  displayName: "EmptyComponent",
  componentId: "sc-yba282-39"
})([""]);
function getTextComponent(textStyle) {
  switch (textStyle) {
    case "h1":
      return H2Bold;
    case "h2":
      return H4Bold;
    case "h3":
      return H8Bold;
    case "h4":
      return H8Regular;
    case "h5":
      return H8Bold;
    case "h6":
      return H6Bold;
    case "h7":
      return H10Bold;
    case "body1":
      return B1Regular;
    case "body2":
      return B2Regular;
    case "body3":
      return B3Regular;
    case "p-body3":
      return PB3Regular;
    case "caption":
      return B4Regular;
    default:
      return EmptyComponent;
  }
}
function getTextStyle(textStyle) {
  switch (textStyle) {
    case "h1":
      return H2BoldStyle;
    case "h2":
      return H4BoldStyle;
    case "h3":
      return H8BoldStyle;
    case "h4":
      return H8RegularStyle;
    case "h5":
      return H8BoldStyle;
    case "h6":
      return H9BoldStyle;
    case "h7":
      return H10BoldStyle;
    case "body1":
      return B1RegularStyle;
    case "body2":
      return B2RegularStyle;
    case "body3":
      return B3RegularStyle;
    case "caption":
      return B4RegularStyle;
  }
}
function getTextStyleV2(textStyle) {
  switch (textStyle) {
    case "h1Regular":
      return H1RegularStyle;
    case "h1Bold":
      return H1BoldStyle;
    case "h2Regular":
      return H2RegularStyle;
    case "h2Bold":
      return H2BoldStyle;
    case "h3Regular":
      return H3RegularStyle;
    case "h3Bold":
      return H3BoldStyle;
    case "h4Regular":
      return H4RegularStyle;
    case "h4Bold":
      return H4BoldStyle;
    case "h5Regular":
      return H5RegularStyle;
    case "h5Bold":
      return H5BoldStyle;
    case "h6Regular":
      return H6RegularStyle;
    case "h6Bold":
      return H6BoldStyle;
    case "h7Regular":
      return H7RegularStyle;
    case "h7Bold":
      return H7BoldStyle;
    case "h8Regular":
      return H8RegularStyle;
    case "h8Bold":
      return H8BoldStyle;
    case "h9Regular":
      return H9RegularStyle;
    case "h9Bold":
      return H9BoldStyle;
    case "h10Regular":
      return H10RegularStyle;
    case "h10Bold":
      return H10BoldStyle;
    case "b1Regular":
      return H1RegularStyle;
    case "b1Bold":
      return H1BoldStyle;
    case "pB1Regular":
      return pB1RegularStyle;
    case "pB1Bold":
      return pB1BoldStyle;
    case "b2Regular":
      return B2RegularStyle;
    case "b2Bold":
      return B2BoldStyle;
    case "pB2Regular":
      return pB2RegularStyle;
    case "pB2Bold":
      return pB2BoldStyle;
    case "b3Regular":
      return B3RegularStyle;
    case "b3Bold":
      return B3BoldStyle;
    case "pB3Regular":
      return pB3RegularStyle;
    case "pB3Bold":
      return pB3BoldStyle;
    case "b4Regular":
      return B4RegularStyle;
    case "b4Bold":
      return B4BoldStyle;
    case "pB4Regular":
      return pB4RegularStyle;
    case "pB4Bold":
      return pB4BoldStyle;
  }
}

export { B1Bold, B1BoldStyle, B1Regular, B1RegularStyle, B2Bold, B2BoldStyle, B2Regular, B2RegularStyle, B3Bold, B3BoldStyle, B3Regular, B3RegularStyle, B4Bold, B4BoldStyle, B4Regular, B4RegularStyle, BODY_THREE_LINE_HEIGHT, BODY_TWO_LINE_HEIGHT, CaptionBold, CaptionBoldStyle, CaptionRegular, CaptionRegularStyle, H10Bold, H10BoldStyle, H10Regular, H10RegularStyle, H1Bold, H1BoldStyle, H1Regular, H1RegularStyle, H2Bold, H2BoldStyle, H2Regular, H2RegularStyle, H3Bold, H3BoldStyle, H3Regular, H3RegularStyle, H4Bold, H4BoldStyle, H4Regular, H4RegularStyle, H5Bold, H5BoldStyle, H5Regular, H5RegularStyle, H6Bold, H6BoldStyle, H6Regular, H6RegularStyle, H7Bold, H7BoldStyle, H7Regular, H7RegularStyle, H8Bold, H8BoldStyle, H8Regular, H8RegularStyle, H9Bold, H9BoldStyle, H9Regular, H9RegularStyle, Label, LabelStyle, PB1Bold, PB1Regular, PB2Bold, PB2Regular, PB3Bold, PB3Regular, PB4Bold, PB4Regular, getTextComponent, getTextStyle, getTextStyleV2, pB1BoldStyle, pB1RegularStyle, pB2BoldStyle, pB2RegularStyle, pB3BoldStyle, pB3RegularStyle, pB4BoldStyle, pB4RegularStyle };
